import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_WARMUP_03: ReviewedLibraryIdentity[] = [
  {
    "id": "library-ksw-warmup-foam-tfl",
    "name": "训练前泡沫轴松解·阔筋膜张肌",
    "group": "warmup",
    "subCategory": "hip-leg",
    "equipment": "foam-roller",
    "pattern": "阔筋膜张肌训练前滚压松解",
    "legacyIds": [
      "ksw-warmup-foam-tfl"
    ],
    "sourceId": "course-20261008-ksw-collection-03-05",
    "targetMuscles": [
      "阔筋膜张肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-warmup-foam-tibialis",
    "name": "训练前泡沫轴松解·胫骨前肌",
    "group": "warmup",
    "subCategory": "hip-leg",
    "equipment": "foam-roller",
    "pattern": "胫骨前肌训练前滚压松解",
    "legacyIds": [
      "ksw-warmup-foam-tibialis"
    ],
    "sourceId": "course-20261008-ksw-collection-03-04",
    "targetMuscles": [
      "胫骨前肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-threeway-shoulder-warmup",
    "name": "肩部综合热身",
    "group": "warmup",
    "subCategory": "shoulder",
    "equipment": "bodyweight",
    "pattern": "徒手肩关节综合活动",
    "legacyIds": [
      "threeway-shoulder-warmup"
    ],
    "sourceId": "course-20261008-fanjue-plan-12-01",
    "targetMuscles": [
      "肩袖肌群",
      "肩胛稳定肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-threeway-back-warmup",
    "name": "背部综合热身",
    "group": "warmup",
    "subCategory": "back",
    "equipment": "bodyweight",
    "pattern": "背部肩胛综合活动",
    "legacyIds": [
      "threeway-back-warmup"
    ],
    "sourceId": "threeway-back-warmup",
    "targetMuscles": [
      "背部稳定肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-threeway-dumbbell-shoulder-activation",
    "name": "哑铃肩部激活",
    "group": "warmup",
    "subCategory": "shoulder",
    "equipment": "dumbbell",
    "pattern": "小负重肩关节活动",
    "legacyIds": [
      "threeway-dumbbell-shoulder-activation"
    ],
    "sourceId": "threeway-dumbbell-shoulder-activation",
    "targetMuscles": [
      "肩袖肌群",
      "三角肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s2-prep",
    "name": "训练前泡沫轴准备",
    "group": "warmup",
    "subCategory": "full-body",
    "equipment": "foam-roller",
    "pattern": "综合泡沫轴训练前准备",
    "legacyIds": [
      "personal-s2-prep"
    ],
    "sourceId": "course-20261008-personal-02-01",
    "targetMuscles": [
      "肩背部肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s2-ab-wheel-foam",
    "name": "健腹轮与泡沫轴激活",
    "group": "warmup",
    "subCategory": "thoracic",
    "equipment": "foam-roller",
    "pattern": "健腹轮及泡沫轴组合激活",
    "legacyIds": [
      "personal-s2-ab-wheel-foam"
    ],
    "sourceId": "course-20261008-personal-02-02",
    "targetMuscles": [
      "核心稳定肌群",
      "肩胛稳定肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s5-trx-activation",
    "name": "TRX肩部激活",
    "group": "warmup",
    "subCategory": "shoulder",
    "equipment": "trx",
    "pattern": "悬吊肩部活动",
    "legacyIds": [
      "personal-s5-trx-activation"
    ],
    "sourceId": "course-20261008-personal-05-02",
    "targetMuscles": [
      "肩袖肌群",
      "肩胛稳定肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-scapular-activation",
    "name": "凳上肩胛激活",
    "group": "warmup",
    "subCategory": "thoracic",
    "equipment": "bodyweight",
    "pattern": "支撑位肩胛活动",
    "legacyIds": [
      "fanjue-scapular-activation"
    ],
    "sourceId": "course-20261008-fanjue-plan-01-01",
    "targetMuscles": [
      "肩胛稳定肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-standing-chest-shoulder-stretch",
    "name": "站立肩部动态拉伸",
    "group": "warmup",
    "subCategory": "shoulder",
    "equipment": "bodyweight",
    "pattern": "站立肩部动态活动",
    "legacyIds": [
      "fanjue-standing-chest-shoulder-stretch"
    ],
    "sourceId": "course-20261008-fanjue-plan-01-02",
    "targetMuscles": [
      "三角肌",
      "肩袖肌群"
    ],
    "evidence": "现有源只确认肩部姿势，标准库不凭旧名称虚增胸部姿势"
  },
  {
    "id": "library-fanjue-elbow-bench-stretch",
    "name": "凳上肘撑肩部活动",
    "group": "warmup",
    "subCategory": "shoulder",
    "equipment": "bodyweight",
    "pattern": "凳上肘撑肩活动",
    "legacyIds": [
      "fanjue-elbow-bench-stretch"
    ],
    "sourceId": "course-20261008-fanjue-plan-04-02",
    "targetMuscles": [
      "肩部肌群",
      "背阔肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-spider-warmup",
    "name": "蜘蛛式热身",
    "group": "warmup",
    "subCategory": "hip-leg",
    "equipment": "bodyweight",
    "pattern": "蜘蛛式髋活动",
    "legacyIds": [
      "fanjue-spider-warmup"
    ],
    "sourceId": "course-20261008-fanjue-plan-04-01",
    "targetMuscles": [
      "髋部肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  }
];
